// Auto-generated version file
// This file is generated during the build process
window.APP_VERSION = {
    version: '0.9.21',
    gitCommit: 'af5aa881ddea4f9ade1612b607432a84e0a7a295',
    buildDate: '2026-08-12T11:15:30.457Z',
    environment: 'production'
};

// Update version in footer
document.addEventListener('DOMContentLoaded', function() {
    const versionElement = document.getElementById('appVersion');
    if (versionElement) {
        versionElement.textContent = window.APP_VERSION.version + ' (' + window.APP_VERSION.gitCommit.substring(0, 7) + ')';
    }
});